let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fjDfr")).then(() => parcelRequire('igCCt'));